import { render, staticRenderFns } from "./AccountMetadataFields.vue?vue&type=template&id=5e029fa6&"
import script from "./AccountMetadataFields.vue?vue&type=script&lang=ts&"
export * from "./AccountMetadataFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports